<template>
  <div v-if="dataOrigin.state === 'done'" class="done">no need</div>
</template>

<script>
export default {
  props: {
    dataOrigin: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.done {
  width: 100%;
  height: 100%;
  background: #333;
}
</style>
